import * as React from 'react'
import { createContext } from 'use-context-selector'
import { useAppContextState } from 'app/@hooks'

const Context = createContext({})

// Granular shape published by /api/packages/table (Phase 7.2):
//   - cells:                  granular {id_hotel, date_from, id_site} cells
//   - summary.min_by_hotel:   {id_hotel: {date_from: cell, ..., avg_min_hotel_prices, hotel_name, is_main, ...}}
//   - hotels / sites:         metadata arrays in selector order
//   - avgCompsetByDate:       {date_from: {priceDashboard, vs_main_diff_perc}, avg_min_hotel_prices}
//   - tableDates:             ordered list of YYYYMMDD strings rendered as columns
//   - idMainHotel / mainHotelIds / idMainHotelCustomPinned: pin echo
const initialState = {
    isLoading: false,
    tableDates: [],
    mainHotelIds: [],
    idMainHotel: null,
    cells: [],
    summary: { min_by_hotel: {} },
    hotels: [],
    sites: [],
    avgCompsetByDate: null,
    idMainHotelCustomPinned: null,
}

export function PackagesPriceTableDataProvider({children}) {
    const { state, updateState } = useAppContextState(initialState)

    return <Context.Provider value={{ state, updateState }}>
        {children}
    </Context.Provider>
}

export default Context